export default __webpack_public_path__ + "static/media/logo.a54fbd29.svg";